import firebase from 'firebase'
import 'firebase/firestore'

import constants from '../utils/constants'

firebase.initializeApp(constants.firebaseConfig)
const db = firebase.firestore()
const storage = firebase.storage().ref()
const auth = firebase.auth()

export { db, storage, auth }
